
import { MedicationInventory } from "../../../interfaces/pharmacy";

export const mockInventory: MedicationInventory[] = [
  {
    id: "MED-001",
    medicationName: "Panadol",
    genericName: "Paracetamol",
    dosageForms: "500mg Tablet",
    currentStock: 1500,
    status: "In Stock",
    supplier: "Lebanese Drug Corp",
  },
  {
    id: "MED-002",
    medicationName: "Augmentin",
    genericName: "Amoxicillin/clavulanate",
    dosageForms: "625mg Tablet",
    currentStock: 250,
    status: "In Stock",
    supplier: "Pharma International",
  },
  {
    id: "MED-003",
    medicationName: "Concor",
    genericName: "Bisoprolol",
    dosageForms: "5mg Tablet",
    currentStock: 45,
    status: "Low Stock",
    supplier: "General Medical Supplies",
  },
  {
    id: "MED-004",
    medicationName: "Epanutin",
    genericName: "Phenytoin",
    dosageForms: "100mg Capsule",
    currentStock: 0,
    status: "Out of Stock",
    supplier: "Pharma International",
  },
  {
    id: "MED-005",
    medicationName: "Advil",
    genericName: "Ibuprofen",
    dosageForms: "200mg Tablet",
    currentStock: 800,
    status: "In Stock",
    supplier: "Lebanese Drug Corp",
  },
]; 